import { ErrorCode } from "@/providers/error-handler/enums/error-codes.enum";

export function shouldSetServerError(statusCode: ErrorCode): boolean {
  if (
    statusCode === ErrorCode.NOT_FOUND
    || statusCode === ErrorCode.BAD_GATEWAY
    || statusCode === ErrorCode.SERVICE_UNAVAILABLE
  ) {
    return false;
  }

  return statusCode >= ErrorCode.INTERNAL_SERVER_ERROR;
}
